import {createSvgIcon} from '../create-svg-icon';

export const SouthIcon = createSvgIcon(
  <path d="m19 15-1.41-1.41L13 18.17V2h-2v16.17l-4.59-4.59L5 15l7 7 7-7z" />
, 'SouthOutlined');
